/* Fog & Form — fog reveal.
   Marks elements as .ff-reveal and clears them (.ff-in) as they enter the viewport.
   Arms only when JS is present (html.ff-js) and motion is allowed. */
(function () {
  var html = document.documentElement;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (html.classList.contains('shopify-design-mode')) return; // keep the editor honest

  var SELECTOR = [
    '.product-grid__item',
    '.collection-card',
    '.product-card',
    '.featured-blog-posts__card',
    '.blog-post-card',
    '.hero .text-block',
    '.section .text-block.h1',
    '.section .text-block.h2',
    '.section .text-block.h3',
    '.media-block',
    '.image-block',
    '.ff-fg-map',
    '[data-ff-reveal]'
  ].join(',');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('ff-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function arm(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.classList.contains('ff-reveal')) continue;
      // Skip anything nested inside an already-revealing ancestor
      if (n.parentElement && n.parentElement.closest('.ff-reveal')) continue;
      var r = n.getBoundingClientRect();
      // Content already on screen at load should not blink: reveal immediately
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) {
        n.classList.add('ff-reveal');
        // next frame so the transition still plays softly
        requestAnimationFrame(function (el) { return function () { el.classList.add('ff-in'); }; }(n));
        continue;
      }
      n.classList.add('ff-reveal');
      io.observe(n);
    }
  }

  html.classList.add('ff-js');
  arm(document);

  // Re-arm for content the theme streams in (infinite scroll, section rendering, filters)
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) arm(added[j]);
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
